const compareObjects = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2)
}
const copyObject = obj => {
  return JSON.parse(JSON.stringify(obj))
}

const objectTools = {
  compareObjects,
  copyObject
}

export default objectTools



// WEBPACK FOOTER //
// ./src/utils/objects/objectTools.js